(function () {
  const instances = new WeakMap();

  function initTuyaFaq(faqSection) {
    if (!faqSection || instances.has(faqSection)) return;

    const items = Array.from(faqSection.querySelectorAll('.tuya-faq__item'));
    const accordionBehavior = faqSection.getAttribute('data-behavior') || 'multiple';

    items.forEach(item => {
      const button = item.querySelector('.tuya-faq__trigger');
      if (!button) return;

      button.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        
        if (isOpen) {
          item.classList.remove('is-open');
          button.setAttribute('aria-expanded', 'false');
        } else {
          if (accordionBehavior === 'single') {
            items.forEach(otherItem => {
              if (otherItem !== item) {
                otherItem.classList.remove('is-open');
                const otherBtn = otherItem.querySelector('.tuya-faq__trigger');
                if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
              }
            });
          }
          item.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });

    instances.set(faqSection, {
      destroy: function () {
        instances.delete(faqSection);
      }
    });
  }

  function destroyTuyaFaq(faqSection) {
    const instance = instances.get(faqSection);
    if (instance) {
      instance.destroy();
    }
  }

  function initAllTuyaFaqs(root) {
    const scope = root || document;
    
    const faqs = [];
    if (scope.matches && scope.matches('[data-tuya-section="faq"]')) {
      faqs.push(scope);
    }
    
    const elements = scope.querySelectorAll('[data-tuya-section="faq"]');
    elements.forEach(el => faqs.push(el));

    faqs.forEach(initTuyaFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener("DOMContentLoaded", function () {
      initAllTuyaFaqs(document);
    });
  } else {
    initAllTuyaFaqs(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAllTuyaFaqs(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    const faq = event.target.matches && event.target.matches('[data-tuya-section="faq"]')
      ? event.target
      : event.target.querySelector('[data-tuya-section="faq"]');
    if (faq) destroyTuyaFaq(faq);
  });

  document.addEventListener("shopify:block:select", function (event) {
    const item = event.target.closest('.tuya-faq__item');
    if (!item) return;

    const button = item.querySelector('.tuya-faq__trigger');
    const faqSection = event.target.closest('[data-tuya-section="faq"]');
    const accordionBehavior = faqSection ? faqSection.getAttribute('data-behavior') : 'multiple';

    if (faqSection && accordionBehavior === 'single') {
      const allItems = faqSection.querySelectorAll('.tuya-faq__item');
      allItems.forEach(otherItem => {
        if (otherItem !== item) {
          otherItem.classList.remove('is-open');
          const otherBtn = otherItem.querySelector('.tuya-faq__trigger');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    item.classList.add('is-open');
    if (button) button.setAttribute('aria-expanded', 'true');
  });
})();
